const getters = {
  //- Get the state of approved companies criterias
  approvedCompaniesCriterias: state => {
    return state.approved_companies_criterias ? state.approved_companies_criterias : null;
  },
  //- Get the state of non approved companies criterias
  unapprovedCompaniesCriterias: state => {
    return state.unapproved_companies_criterias ? state.unapproved_companies_criterias : null;
  },
  //- Get the state of  isApproved companies criterias
  isApprovedCompanies: state => {
    return state.is_approved_companies ? state.is_approved_companies : null;
  }
};
  
export default getters;
  